import React, { useEffect, useState, forwardRef } from 'react';

import {
    Box,
    Typography,
    Tabs,
    Tab,
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    TextField,
    Grid,
    FormHelperText,
    Divider,
    Checkbox,
    FormGroup,
    FormControlLabel,
    InputAdornment
} from '@mui/material';

import dayjs from 'dayjs';

import { useFormik } from 'formik';

import { useAppContextFeatures } from '../../../context/AppContext';
import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useTranslations } from "../../../hooks/useTranslations";

import { useDocumentValidation, verifyOutDeductionTypes } from "../../../hooks/api/useDocumentValidation"
import { CommonIcons, icons } from '../../common/CommonIcons';

import {
    initialValues,
    // getValidationVerifySchema 
    validationSchema
} from '../../../schema/documents/validation/verifyOutSchema';

// import { useSystemUtils } from '../../../hooks/useSystemUtils';

// import DatePickerComponent from '../../common/DatePickerComponent';

import { useStateInventoryBatches } from "../../../hooks/state/useStateInventoryBatches"


const RenderInventoryBatch = ({
    formik,
    t,
    row,
    getAvailableInventoryBatches,
    isLoadingInventoryBatches,
    getSelectedInventoryBatch,
    RenderValueComponent,
    selectInventoryBatch,
    RenderSubHeaderComponent,
    RenderMenuItemComponent
}) => {

    const { values, errors, touched, handleChange, handleSubmit, setFieldValue } = formik;
    if (isLoadingInventoryBatches) {
        return (
              <TextField
                    margin="dense"
                    size="small"
                    fullWidth
                    placeholder="Loading..."
                    type="text"
                    variant="outlined"
              />
        )
    }

    const itemId = row?.item_id

    const options = getAvailableInventoryBatches({ index: 0, itemId })

    // console.log('options', options)

    return (
          <FormControl
                margin="dense"
                fullWidth
                size="small"
                // error={Boolean(itemErrors?.inventoryBatchId)}
          >
              <InputLabel id="inventoryBatchId">{t('inventory')}</InputLabel>
              <Select
                    disabled={
                        !(itemId)
                    }
                    labelId="inventoryBatchId"
                    label={t('inventory')}
                    name={`inventoryBatchId`}
                    // onChange={handleChange}
                    onChange={(event) => {

                        // console.log('event', event.target.value)

                        let batchId = event.target.value

                        const selectedBatch = selectInventoryBatch({
                            itemId,
                            batchId,
                            selectedIndexNo: 0
                        })

                        // console.log('selectedBatch', selectedBatch)

                        setFieldValue(`inventoryBatchId`, selectedBatch?.batchId)

                        setFieldValue(`inventoryQty`, {
                            ...values.inventoryQty,
                            value: "0",
                            maxQty: parseFloat(selectedBatch?.totalRemainQty),
                        })

                        setFieldValue(`verifyQty`, {
                            ...values.verifyQty,
                            value: "0"
                        })

                        setFieldValue(`expiryDate`, selectedBatch?.expiryDate)
                        setFieldValue(`customBatchNo`, selectedBatch?.customBatchNo)
                        setFieldValue(`rackId`, selectedBatch?.rackId)
                        setFieldValue(`rackDisplay`, selectedBatch?.rackName)
                        setFieldValue(`slotId`, selectedBatch?.slotId)
                        setFieldValue(`slotDisplay`, selectedBatch?.slotName)

                        // setFieldValue(
                        //     `rows.${index}.qty`,
                        //     {
                        //         value: "0",
                        //         maxQty: parseFloat(selectedBatch?.totalRemainQty),
                        //         // skipStockPost: false
                        //     }
                        // )

                    }}
                    renderValue={(value) => {

                        const a = getSelectedInventoryBatch({ selectedIndexNo: 0 })

                        // console.log('a', a)

                        return (
                              <RenderValueComponent item={a}/>
                        )
                    }}
                    value={
                        getSelectedInventoryBatch({ selectedIndexNo: 0 })?.batchId ?
                              getSelectedInventoryBatch({ selectedIndexNo: 0 }).batchId
                              :
                              ""
                    }
                    sx={{
                        textAlign: 'left',
                    }}
                    MenuProps={{
                        MenuListProps: {
                            sx: {
                                py: 0
                            },
                        }
                    }}
              >
                  <RenderSubHeaderComponent/>
                  {
                      options.map((i, index2) => {
                          return (
                                // <RenderMenuItemComponent
                                //     key={index2}
                                //     index={index2}
                                //     item={i}
                                // />
                                RenderMenuItemComponent({
                                    key: index2,
                                    index: index2,
                                    item: i
                                })
                          )
                      })
                  }
              </Select>
              <FormHelperText>
                  {
                      errors?.inventory?.inventoryBatchId ?
                            errors.inventory.inventoryBatchId
                            :
                            getSelectedInventoryBatch({ selectedIndexNo: 0 })?.batchId ?
                                  getSelectedInventoryBatch({ selectedIndexNo: 0 }).label
                                  :
                                  ""
                  }
              </FormHelperText>
          </FormControl>
    )
}

const RenderInventorySelection = ({
    formik,
    t
}) => {
    const { values, errors, touched, handleChange, handleSubmit, setFieldValue } = formik;
    if (!values?.inventoryBatchId) {
        return (
              <Grid item xs={4} sm={4} md={6}>
                  <></>
              </Grid>
        )
    }

    return (
          <>
              <Grid item xs={4} sm={4} md={2}>
                  <TextField
                        disabled
                        margin="dense"
                        size="small"
                        // autoFocus
                        fullWidth
                        name={"slotId"}
                        label={t('slot')}
                        type="text"
                        variant="outlined"
                        value={values?.slotDisplay ? values.slotDisplay: ""}
                        // onChange={handleChange}
                        error={Boolean(errors.slotId)}
                        helperText={errors.slotId}
                  />
              </Grid>
              <Grid item xs={4} sm={4} md={2}>
                  <TextField
                        disabled
                        margin="dense"
                        size="small"
                        // autoFocus
                        fullWidth
                        name={"rackId"}
                        label={t('rack')}
                        type="text"
                        variant="outlined"
                        value={values?.rackDisplay ? values.rackDisplay: ""}
                        // onChange={handleChange}
                        error={Boolean(errors.rackId)}
                        helperText={errors.rackId}
                  />
              </Grid>
              <Grid item xs={4} sm={4} md={2}>
                  <TextField
                        disabled
                        margin="dense"
                        size="small"
                        // autoFocus
                        fullWidth
                        name={"inventory.qty"}
                        label={t('availableQty')}
                        type="text"
                        variant="outlined"
                        value={values?.inventoryQty?.value ? values.inventoryQty.value: "0"}
                        onChange={handleChange}
                        error={Boolean(errors?.inventoryQty?.value)}
                        helperText={errors?.inventoryQty?.value}
                        InputProps={{
                            endAdornment: (
                                  <InputAdornment position="end">
                                      {` / ${parseFloat(values?.inventoryQty?.maxQty)}`}
                                  </InputAdornment>
                            ),
                        }}
                  />
              </Grid>
          </>
    )
}

const RenderNew = ({
    formik,
    t,
    row,
    getAvailableInventoryBatches,
    isLoadingInventoryBatches,
    getSelectedInventoryBatch,
    RenderValueComponent,
    selectInventoryBatch,
    RenderSubHeaderComponent,
    RenderMenuItemComponent
}) => {
    const { values, errors, touched, handleChange, handleSubmit, setFieldValue } = formik;
    return (
          <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={6}>
                      <TextField
                            margin="dense"
                            size="small"
                            // autoFocus
                            fullWidth
                            label={t('itemName')}
                            type="text"
                            variant="outlined"
                            value={values?.itemName}
                            onChange={handleChange}
                            // error={touched.barcode && Boolean(errors.barcode)}
                            // helperText={touched.barcode && errors.barcode}
                            disabled
                      />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6}>
                      <TextField
                            margin="dense"
                            size="small"
                            // autoFocus
                            fullWidth
                            label={t('code')}
                            type="text"
                            variant="outlined"
                            value={values?.itemCode ? values.itemCode: ""}
                            onChange={handleChange}
                            // error={touched.barcode && Boolean(errors.barcode)}
                            // helperText={touched.barcode && errors.barcode}
                            disabled
                      />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                      <Divider/>
                  </Grid>


                  <Grid item xs={6} sm={6} md={6}>
                      < RenderInventoryBatch
                            formik={formik}
                            t={t}
                            row={row}
                            getAvailableInventoryBatches={getAvailableInventoryBatches}
                            isLoadingInventoryBatches={isLoadingInventoryBatches}
                            getSelectedInventoryBatch={getSelectedInventoryBatch}
                            RenderValueComponent={RenderValueComponent}
                            selectInventoryBatch={selectInventoryBatch}
                            RenderSubHeaderComponent={RenderSubHeaderComponent}
                            RenderMenuItemComponent={RenderMenuItemComponent}
                      />
                  </Grid>
                  <RenderInventorySelection
                        formik={formik}
                        t={t}
                  />


                  {/* <Grid item xs={6} sm={6} md={6}>
                        {
                            RenderRackSelect()
                        }

                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                        {
                            RenderSlotSelect()
                        }
                    </Grid> */}

                  {
                        values?.inventoryBatchId &&

                        <Grid item xs={12} sm={12} md={6}>
                            <TextField
                                  margin="dense"
                                  size="small"
                                  // autoFocus
                                  fullWidth
                                  name={"verifyQty.value"}
                                  label={t('requiredQty')}
                                  type="text"
                                  variant="outlined"
                                  value={values?.verifyQty?.value ? values.verifyQty.value: ""}
                                  onChange={(e) => {

                                      setFieldValue(`verifyQty`, {
                                          ...values.verifyQty,
                                          value: parseFloat(e.target.value)
                                      })

                                      setFieldValue(`inventoryQty`, {
                                          ...values.inventoryQty,
                                          value: parseFloat(e.target.value)
                                      })
                                  }}
                                  onFocus={event => {
                                      event.target.select();
                                  }}
                                  error={Boolean(errors?.verifyQty?.value)}
                                  helperText={errors?.verifyQty?.value}
                                  InputProps={{
                                      endAdornment: (
                                            <InputAdornment position="end">
                                                {` / ${parseFloat(values?.verifyQty?.maxQty)}`}
                                            </InputAdornment>
                                      ),
                                  }}
                            />
                        </Grid>
                  }


                  {/* <Grid item xs={12} sm={12} md={6}><></></Grid> */}

                  {/* <Grid item xs={12} sm={12} md={12}>
                        <Divider>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event, newValue) => {
                                            // console.log('event', event.target.value, newValue)
                                            setIsTrackBatch(newValue)
                                        }}
                                        checked={isTrackBatch}
                                        // defaultChecked
                                    />
                                }
                                label="Track Batch Receives"
                            />
                        </Divider>
                    </Grid> */}

                  {/* {
                        RenderBatch()
                    } */}

                  <Grid item xs={12} sm={12} md={12}>
                      <Button
                            variant='contained'
                            fullWidth
                            type='submit'
                      >
                          <CommonIcons name={icons.save}/>
                          <Box sx={{ ml: 1 }}>
                              {t('saveChanges')}
                          </Box>
                      </Button>
                  </Grid>
              </Grid>
          </form>
    )
}

export default function VerifyOutNew(
      {
          locationId,
          row,
          rackData,
          documentType,
          targetType,
          actionType,
          handleOnSuccess,
      }
) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const { promptMessage } = useSystemPrompt()
    const { setSystemLoading } = useAppContextFeatures()
    // const { formatDateTimeDisplay } = useSystemUtils();

    const { performVerifyOut } = useDocumentValidation({ documentType, targetType, actionType })

    // const [ isTrackBatch, setIsTrackBatch ] = useState(false)

    const {
        document_id: documentId,
        unverify_out_qty: unVerifyQty
    } = row

    const {
        isLoading: isLoadingInventoryBatches,
        skipBatchId,
        // skipIndexNoArray,
        dataInventoryBatches,
        resetDataInventoryBatches,
        selectInventoryBatch,
        getInventoryBatchesByItemId,
        getSelectedInventoryBatch,
        appendInventoryBatch,
        removeAllSelectedIndexNo,
        RenderValueComponent,
        RenderSubHeaderComponent,
        RenderMenuItemComponent,
    } = useStateInventoryBatches({
        locationId
    })

    // console.log('row', row)

    const onSubmit = async (currentValues) => {

        setSystemLoading(true);

        try {

            let verifyOut = {
                slot_id: currentValues?.slotId,
                code: currentValues?.itemCode,
                uid_barcode: "",
                custom_batch_no: currentValues?.customBatchNo,
                expiry_date: currentValues?.expiryDate // ? dayjs(currentValues.expiryDate).format("YYYY-MM-DD") : ""
            }

            let item = {
                doc_item_id: currentValues?.docItemId,
                verify_out_qty: currentValues?.verifyQty.value,
                verify_out_type: verifyOutDeductionTypes.specific,
                verify_out: verifyOut
            }

            const data = [item]

            const response = await performVerifyOut({ id: documentId, data });

            // console.log('response', response)

            promptMessage(true, t(`changesSaved`), response)

            // fetchData();
            if (handleOnSuccess) handleOnSuccess()

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

    }

    const getSchema = () => {

        return validationSchema
        // getValidationVerifySchema({ maxQty: unVerifyQty, enableTrackBatch: isTrackBatch })
    }

    const formik = useFormik({
        initialValues,
        validationSchema: getSchema(),
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, handleSubmit, setFieldValue } = formik;

    useEffect(() => {

        console.log('code', row)

        // assign the values into state formik
        setFieldValue(`itemCode`, row?.code)
        setFieldValue(`docItemId`, row?.id)
        setFieldValue('itemName', row?.item_name)
        setFieldValue(`verifyQty`, {
            ...values.verifyQty,
            maxQty: parseFloat(unVerifyQty)
        })

        // append the batch info 
        appendInventoryBatch({ itemId: row?.item_id, selectedIndexNo: 0 })

    }, [])

    const getRacks = () => {

        return rackData
    }

    const getSlots = ({ rackId }) => {

        if (!rackId) return []

        const rack = rackData.filter(item => item.id === rackId)

        return rack && rack.length ? rack[0]._slots: []
    }

    // able to filter out the inventory batches been selected even for the same uom id
    const getAvailableInventoryBatches = ({ index, itemId }) => {

        const selected = getInventoryBatchesByItemId({ itemId, selectedIndexNo: index })

        // console.log('selec', selected)

        // get the row type of the state
        // const rowFromType = values.rows[index].rowFromType

        // if(!rowFromType) return []

        let data = selected.filter(i => i.batchId !== 'skip')

        // console.log('selected', data, rowFromType)

        // if the row type is normal
        // if(rowFromType === 'normal'){
        //     data = data.filter(i => i.rackType !== 'reserve')
        // }

        // // if the row type is reserve
        // if(rowFromType === 'reserved'){
        //     data = data.filter(i => i.rackType === 'reserve')
        // }

        return data;
    }


    return (
          <Box
                sx={{
                    p: 2
                }}
          >
              {/* {JSON.stringify(values)} */}
              {/* {JSON.stringify(errors)} */}

              {/* <Typography sx={{ fontSize: 10 }}>
                {JSON.stringify(dataInventoryBatches)}
            </Typography> */}
              <RenderNew
                    formik={formik}
                    t={t}
                    row={row}
                    getAvailableInventoryBatches={getAvailableInventoryBatches}
                    isLoadingInventoryBatches={isLoadingInventoryBatches}
                    getSelectedInventoryBatch={getSelectedInventoryBatch}
                    RenderValueComponent={RenderValueComponent}
                    selectInventoryBatch={selectInventoryBatch}
                    RenderSubHeaderComponent={RenderSubHeaderComponent}
                    RenderMenuItemComponent={RenderMenuItemComponent}
              />

          </Box>
    )
}